import { render, staticRenderFns } from "./commentsUl_waterfall.vue?vue&type=template&id=2a1ec79e&scoped=true&"
import script from "./commentsUl_waterfall.vue?vue&type=script&lang=js&"
export * from "./commentsUl_waterfall.vue?vue&type=script&lang=js&"
import style0 from "./commentsUl_waterfall.vue?vue&type=style&index=0&id=2a1ec79e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1ec79e",
  null
  
)

export default component.exports